import { MultiSelect } from '@frontend/components/ui/multi-select'
import { CLIENT_STATUSES, CLIENT_STATUS_LABELS, type ClientStatus } from '@common/utils/clientStatus'

interface StatusFilterProps {
  selected: ClientStatus[]
  onChange: (selected: ClientStatus[]) => void
  className?: string
}

const STATUS_OPTIONS = CLIENT_STATUSES.map((status) => ({
  value: status,
  label: CLIENT_STATUS_LABELS[status],
}))

/**
 * Multi-select filter for client status.
 * Wraps the existing MultiSelect component with status-specific options.
 */
export function StatusFilter({ selected, onChange, className }: StatusFilterProps) {
  return (
    <MultiSelect
      options={STATUS_OPTIONS}
      selected={selected}
      onChange={(values) => onChange(values as ClientStatus[])}
      placeholder="Filter by status..."
      searchPlaceholder="Search statuses..."
      emptyMessage="No statuses found."
      className={className}
    />
  )
}
